import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import {IntegrationTypes} from '@core/models/types/integration-types';
import {PermissionTypes} from '@core/models/types/permission-types';

export const menuItems: MenuItem[] = [
  {
    label: 'Overview',
    icon: 'home',
    route: '/home',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.HOME,
  },
  {
    label: 'Permissions',
    icon: 'manage_accounts',
    route: '/permissions',
    data: {
      integrationId: IntegrationTypes.SqeptechConnect,
      requiredPermission: PermissionTypes.ManagePermissions,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.PERMISSIONS,
  },
  {
    label: 'Connect',
    icon: "bus",
    route: '/integrations/sqeptech/management',
    data: {
      integrationId: IntegrationTypes.SqeptechConnect,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_SQEPTECH,
    divideAfter: true,
    showMenuItem: true
  },
  {
    label: 'CPR',
    icon: "integrations",
    route: '/integrations/cpr/management',
    data: {
      integrationId: IntegrationTypes.CPR,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_CPR
  },
  {
    label: 'Lessor',
    icon: "integrations",
    route: '/integrations/lessor/management',
    data: {
      integrationId: IntegrationTypes.Lessor,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_LESSOR,
  },
  {
    label: 'Promark',
    icon: "integrations",
    route: '/integrations/promark/management',
    data: {
      integrationId: IntegrationTypes.Promark,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_PROMARK,
  },
  {
    label: 'Teta',
    icon: "integrations",
    route: '/integrations/teta/management',
    data: {
      integrationId: IntegrationTypes.Teta,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_TETA,
  },
  {
    label: 'TMS',
    icon: "integrations",
    route: '/integrations/tms/management',
    data: {
      integrationId: IntegrationTypes.TMS,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_TMS,
  },
  {
    label: 'Unit4',
    icon: "integrations",
    route: '/integrations/unit4/management',
    data: {
      integrationId: IntegrationTypes.Unit4,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_UNIT4,
  },
  {
    label: 'Visma',
    icon: "integrations",
    route: '/integrations/visma/management',
    data: {
      integrationId: IntegrationTypes.Visma,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_VISMA,
  },
  {
    label: 'Dalco - AFAS',
    icon: "integrations",
    route: '/integrations/dalcoafas/management',
    data: {
      integrationId: IntegrationTypes.DalcoAfas,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_DALCOAFAS,
  },
  {
    label: 'Foppen - AFAS',
    icon: "integrations",
    route: '/integrations/foppenafas/management',
    data: {
      integrationId: IntegrationTypes.FoppenAfas,
      requiredPermission: PermissionTypes.View,
    },
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.INTEGRATIONS_FOPPENAFAS,
  }
];
